<div class="page-content page-fill">
  <div class="card mb-3">
    <div class="card-body">
      <dx-text-box style="min-width: 300px" [placeholder]="'Search'" [(value)]="searchValue" (onBlur)="onSearch($event)"></dx-text-box>
      <dx-select-box
        class="mt-2 household-select-box"
        [placeholder]="'Household'"
        [items]="households"
        [(value)]="selectedHouseholdId"
        valueExpr="id"
        displayExpr="name"
        tabindex="-1"
        [showClearButton]="true"
        (onSelectionChanged)="onSearch($event)"
      ></dx-select-box>
      @if (isReady) {
        <div class="d-flex flex-row flex-wrap justify-content-left">
          @for (pic of families; track pic) {
            <div>
              <div class="card mt-2 ms-3 mb-3" [ngClass]="'black-border'">
                <a (click)="openFamily(pic)">
                  <div class="card-header pb-1">
                    <h3 class="card-title">{{ pic.name }}</h3>
                  </div>
                  <div class="card-body">
                    @if (pic.photoUrl) {
                      <div class="ms-3" style="width: 150px">
                        <img src="{{ pic.photoUrl }}" class="w-100" />
                      </div>
                    }
                  </div>
                </a>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
